module.exports = __webpack_public_path__ + "static/media/bang.1607a438.png";